export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_USER_EXPORT_LIST = 'GET_USER_EXPORT_LIST';
export const SET_USER_EXPORT_LIST = 'SET_USER_EXPORT_LIST';
export const GET_NEXT_PAGE_USER_LIST = 'GET_NEXT_PAGE_USER_LIST';
export const SET_USER_LIST = 'SET_USER_LIST';
export const GET_ROLE = 'GET_ROLE';
export const SET_ROLE = 'SET_ROLE';
export const INACTIVE_USER = 'INACTIVE_USER';
export const INACTIVE_USER_SUCCESS = 'INACTIVE_USER_SUCCESS';
export const UPDATE_URLS = 'UPDATE_URLS';
export const UPDATE_URL_ERROR = 'UPDATE_URL_ERROR';
export const UPDATE_URL_SUCCESS = 'UPDATE_URL_SUCCESS';
export const SWITCH_ROLE = 'SWITCH_ROLE';
export const SWITCH_ROLE_SUCCESS = 'SWITCH_ROLE_SUCCESS';
export const SELECT_LANGUAGE = 'SELECT_LANGUAGE';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS';
